<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入商品</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="`/supply/shipment/downloadShipmentProductTemp?areCasesRequired=${areCasesRequired}`"
          container-type="shipmentProduct"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 10px;"
      ></gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls/xlsx的文件',
            '同一个MSKU存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../../../../minxins";
  import {importShipmentProduct} from "../../../../../../../api/logistics";

  export default {
    name: "app-import-product-modal",
    mixins: [modalMixIn, uploadMixin],
    props: {
      areCasesRequired: {
        type: Boolean
      },
      hideMskuList: {
        default: () => []
      },
      countryCode: {
        required: true
      },
      warehouseId: {
        required: true
      }
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importShipmentProduct({
          areCasesRequired: this.areCasesRequired,
          attachmentId: attId,
          countryCode: this.countryCode,
          hideMskuList: this.hideMskuList,
          warehouseId: this.warehouseId
        })
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>











